const TOKEN_KEY = "connect.sid";

export const saveSessionId = (sid: string) =>
  sessionStorage.setItem(TOKEN_KEY, sid);

export const destroySessionId = () => sessionStorage.removeItem(TOKEN_KEY);

export const getSessionId = () => sessionStorage.getItem(TOKEN_KEY);
